import styled from 'styled-components';
import { device } from '../../styles/devices';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  width?: string;
  height?: string;
  isOpen?: boolean;
}

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  padding: ${SIZING.unit(0)};
  z-index: 1000;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  @media ${device.tablet} {
    justify-content: center;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    justify-content: unset;
  }
  * {
    // ASK
    box-sizing: border-box;
  }
`;

export const ModalContainer = styled.div`
  position: relative;
  width: ${({ width }: StyleProps) => width || '100%'};
  margin-top: ${SIZING.unit(7.875)};
  // height: 100%;
  min-height: ${({ height }: StyleProps) => height};
  margin: ${SIZING.unit(0)} auto;
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.white};
  overflow-y: auto;
  text-align: justify;
  margin-top: ${SIZING.unit(0)};
  @media ${device.tablet} {
    margin-top: ${SIZING.unit(0)};
    max-height: 766px;
    height: 766px;
    max-width: 616px;
    min-height: unset;
  }
  @media (max-width: 926px) and (max-height: 600px) and (orientation: landscape) {
    flex-direction: row;
    margin-top: ${SIZING.unit(0)};
    max-width: unset;
    min-height: ${({ height }: StyleProps) => height};
  }
`;
